import { FaWhatsapp } from "react-icons/fa";
import { UserIcon } from "lucide-react";

import { config } from "../../Config";
import useScroll from "../../hooks/useScroll";

const Header = () => {
  const isScrolled = useScroll(100);

  return (
    <div className={`max-h-[5rem] shadow-lg w-screen bg-secondary-color`}>
      <div className="w-full max-h-[5rem] max-w-[85rem] mx-auto xl:px-4 px-6 py-2 flex justify-between items-center gap-2">
        <div className="w-full flex justify-start items-start gap-6">
          <img
            src="/tim/images/logos/logo-tim.webp"
            alt="Logo TIM"
            width={90}
            height={30}
          />
          <img
            src="/tim/images/logos/logo_topen_white.webp"
            alt="Logo Thopen"
            width={110}
            height={30}
          />
        </div>
        <div className="flex justify-center items-center gap-4 lg:px-2">
          <button
            onClick={(e) => {
              const aEl = document.createElement("a");
              aEl.href = config.url.urlLoginPortal;
              aEl.target = "_blank";
              aEl.click();
            }}
            className="max-md:hidden h-[3.313rem] px-6 py-4 rounded-xl border border-white justify-start items-center inline-flex hover:opacity-70 transition-all duration-150 ease-linear text-center text-white text-sm font-normal  leading-[21px] text-nowrap"
            aria-label="Área do associado"
          >
            Área do Associado
          </button>
          <a
            href="https://wa.me/551148633465"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="max-md:hidden h-[3.313rem] px-6 py-4 rounded-xl border border-white justify-start items-center inline-flex hover:opacity-70 transition-all duration-150 ease-linear text-center text-white text-sm font-normal  leading-[21px] text-nowrap"
          >
            <FaWhatsapp size={24} color="#fff" />
          </a>
          <button
            onClick={(e) => {
              const aEl = document.createElement("a");
              aEl.href = config.url.urlLoginPortal;
              aEl.target = "_blank";
              aEl.click();
            }}
            className="md:hidden flex h-[3.313rem] justify-start items-center hover:opacity-70 transition-all duration-150 ease-linear"
            aria-label="Área do associado"
          >
            <UserIcon size={24} color="#fff" />
          </button>
          <a
            href="https://wa.me/551148633465"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="md:hidden flex h-[3.313rem] justify-start items-center hover:opacity-70 transition-all duration-150 ease-linear"
          >
            <FaWhatsapp size={24} color="#fff" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
